import { IBrand, IBrandContent, IBrandPageContent } from '@shared/types/IBrand';

const isBrandPageContent = (brand: IBrandPageContent | IBrandContent): brand is IBrandPageContent =>
  brand.content?.component === 'BrandPage';

export const mapBrand = (brand: IBrandPageContent | IBrandContent): IBrand | null => {
  const brandContent = isBrandPageContent(brand)
    ? brand?.content?.content?.[0]?.brand?.content
    : brand?.content;
  const brandMeta = brand?._meta;

  if (!brandContent || !brandContent.name || !brandMeta.slug) return null;

  return {
    name: brandContent?.name,
    logo: brandContent?.logo,
    description: brandContent?.description,
    slug: brandMeta?.slug,
  };
};

// interface and function below used by RSP which still uses vuex store – should be removed
interface IBrandContentRSP {
  content: {
    content: [
      {
        brand: {
          content: {
            logo: {
              filename: string;
              alt: string;
            };
            name: string;
            description: {
              content: unknown[];
            };
            product_category?: {
              shopify_category?: {
                items?: {
                  name: string;
                }[];
              };
            }[];
          };
        };
      },
    ];
  };
  _meta: {
    slug: string;
    full_slug: string;
  };
}

const VENDOR_CATEGORY_PREFIX = 'AUTOGEN::Brands>';
export const mapVendorsToBrandSlugs = (brands: IBrandContentRSP[] = []) =>
  brands.reduce((map: Record<string, string>, brand: IBrandContentRSP) => {
    const shopifyCategory =
      brand.content?.content?.[0]?.brand?.content?.product_category?.[0]?.shopify_category
        ?.items?.[0]?.name || '';

    if (!shopifyCategory.startsWith(VENDOR_CATEGORY_PREFIX)) {
      return map;
    }

    const vendor = shopifyCategory.replace(VENDOR_CATEGORY_PREFIX, '');
    const slug = brand._meta?.full_slug;

    if (vendor && slug) {
      map[vendor] = `/${slug}`;
    }

    return map;
  }, {});
